import { createContext } from "react";

const htmlProcessorContext = createContext();

export default htmlProcessorContext;
